import { Roles } from "@/auth/permissions";
import WebIngestion from "@/components/WebIngestion/WebIngestion";
import { ENABLE_INTERNAL_DEBUGGER } from "@/config/constants";
import DesignSystemPage from "@/features/design-system";
import { TaskModal } from "@/features/tasks/TaskModal";
import NotFoundPage from "@/pages/404";
import Authcallback from "@/pages/Authcallback";
import Forbidden from "@/pages/Forbidden";
import LoggedOut from "@/pages/LoggedOut";
import LoginError from "@/pages/LoginError";
import SignInPage from "@/pages/SignIn";
import { Events } from "@/pages/events/Events";
import InternalDebuggerPage from "@/pages/internal-debugger/InternalDebuggerPage";
import { lazy } from "react";
import { Redirect } from "react-router-dom";
import { admin } from "./admin";
import { build } from "./build";
import { monitor } from "./monitor";
import { projects } from "./projects";
import { verify } from "./verify";
const EventIndexHealPage = lazy(() => import("@/pages/internal/EventIndexHealPage"));

const HomeRedirect = () => {
  return <Redirect to={{ pathname: "/projects" }} />;
};

const routes = (
  [
    {
      path: "/",
      component: HomeRedirect,
      layout: "decisively",
      exact: true,
      // This should change in future when the dashboard becomes something that isn't just viewing all projects
      role: [Roles.ProjectReader, Roles.ProjectWriter, Roles.ProjectTechnical],
    },
    ...projects,
    ...build,
    ...monitor,
    ...verify,
    ...admin,
    {
      path: "/loggedOut",
      component: LoggedOut,
      layout: "centered",
      exact: true,
    },
    {
      path: "/signin",
      component: SignInPage,
      exact: true,
      layout: "centered",
    },
    {
      path: "/authcallback",
      layout: "centered",
      component: Authcallback,
      exact: true,
    },
    {
      path: "/login_error",
      layout: "centered",
      component: LoginError,
      exact: true,
    },
    {
      path: "/forbidden",
      layout: "centered",
      component: Forbidden,
      exact: true,
    },
    {
      path: "/task/:id",
      component: TaskModal,
      layout: "decisively",
      exact: true,
      role: [Roles.ProjectReader, Roles.ProjectWriter, Roles.ProjectTechnical],
    },
    {
      path: "/events",
      component: () => <Events source="tenancy" />,
      layout: "decisively",
      exact: true,
      role: [Roles.TimesheetAdmin, Roles.SuperAdmin, Roles.Owner],
    },
  ] as any[]
)
  .concat(
    ENABLE_INTERNAL_DEBUGGER
      ? [
          {
            path: "/internal-debugger",
            component: InternalDebuggerPage,
            layout: "decisively",
            exact: true,
            role: [Roles.SuperAdmin],
          },
        ]
      : [],
  )
  .concat(
    import.meta && import.meta.env && import.meta.env.DEV
      ? [
          {
            path: "/design",
            component: DesignSystemPage,
            layout: "decisively",
            exact: false,
            role: [Roles.SuperAdmin],
          },
          {
            path: "/internal/event-index-heal",
            component: EventIndexHealPage,
            layout: "decisively",
            exact: true,
            role: [Roles.SuperAdmin],
          },
        ]
      : [],
  )
  .concat({
    path: "/:NoMatch",
    component: NotFoundPage,
    layout: "centered",
    exact: false,
  });

export default routes;
